import { transformDateValue } from 'core/js/FormUtils';
export const getAssetsView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let assetsList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Path","fieldValue":transformDataValue(data.path,"string"), "fieldType":"string"},
                            {"fieldLabel":"Asset Type","fieldValue":transformDataValue(data.assettype,"number"), "fieldType":"number"},
                            {"fieldLabel":"Product Id","fieldValue":transformDataValue(data.productid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Dam Asset Id","fieldValue":transformDataValue(data.damassetid,"ID"), "fieldType":"ID"},
              
              
            ],
            'dataList': [
                
              ]
          }

          assetsList.push(card);
  })
  return assetsList;
}